import { createFileRoute } from "@tanstack/react-router";
import HerramientasParaRetail from "@/pages/HerramientasParaRetail";

const title = "Herramientas para retail y hostelería | Retail Lemon";
const description = "Calculadora, KPIs, subvenciones, proveedores, música y aroma para el local..";

export const Route = createFileRoute("/herramientas/")({
  head: () => ({ meta: [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
  ] }),
  component: () => <HerramientasParaRetail routeLang="es" />,
});
